<template>
  <v-container fluid px-0>
    <v-row>
      <v-col sm="4"
        ><basic-data-table :items="availDocs" :headers="availDocsHeaders">
          <template v-slot:title>
            <h3 class="subtitle-1">Available Documents</h3>
          </template></basic-data-table
        >
        <v-row justify="center">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on"> Export & Generate </v-btn>
            </template>
            <v-list>
              <v-list-item @click="generateMHikes" v-if="mhikesAvailable">
                <v-list-item-title>Export to MHikes</v-list-item-title>
              </v-list-item>
              <v-list-item @click="generateTravefy" v-if="travefyAvailable">
                <v-list-item-title>Export to Travefy</v-list-item-title>
              </v-list-item>
              <v-list-item @click="generateAxus" v-if="axusAvailable">
                <v-list-item-title>Export to Axus</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="generateSPCalendar"
                v-if="spCalendarAvailable"
              >
                <v-list-item-title>Export to SP Calendar</v-list-item-title>
              </v-list-item>
              <v-list-item @click="safariMapping" v-if="safariAvailable">
                <v-list-item-title>Safari Mapping</v-list-item-title>
              </v-list-item>
              <v-list-item @click="generateSafari" v-if="safariAvailable">
                <v-list-item-title>Export to Safari</v-list-item-title>
              </v-list-item>
              <v-list-item @click="generateWetu" v-if="wetuAvailable">
                <v-list-item-title>Export to Wetu</v-list-item-title>
              </v-list-item>

              <v-list-item
                @click="generateLuggageCSV"
                v-if="luggageCSVAvailable"
              >
                <v-list-item-title>Export Luggage CSV</v-list-item-title>
              </v-list-item>
              <v-list-item @click="generateSalesInvoices">
                <v-list-item-title>Generate Sales Invoice(s)</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="onGenerateItineraryMap"
                v-if="$store.getters.hasAccessTo('itineraries:map_generator')"
              >
                <v-list-item-title>Generate Itinerary Map</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-row></v-col
      >
      <v-col sm="8">
        <basic-data-table
          :headers="headers"
          :items="items"
          @rowAction="handleRowAction"
          :loading="$apollo.loading"
          :sortBy="docsSortBy"
          :sortDesc="docsSortDesc"
          ><template v-slot:title>
            <h3 class="subtitle-1">Generated Documents</h3>
          </template>
          <template v-slot:filters>
            <v-select
              v-model="documentTypeFilter"
              :items="documentTypes"
              item-text="label"
              item-value="code"
              label="Hide Document Type"
              :outlined="outlinedInputs"
              hide-details
              dense
              class="ml-1"
              multiple
              chips
              clearable
            ></v-select>
          </template>
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn class="mr-3" v-on="on" icon @click="onReloadList">
                  <v-icon dark>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh List</span>
            </v-tooltip>
          </div>
        </basic-data-table>
        <v-btn
          :loading="uploading"
          :disabled="uploading"
          color="blue-grey"
          class="ma-2 white--text"
          @click="onUpload"
        >
          Attach a File
          <v-icon right dark>mdi-cloud-upload</v-icon>
        </v-btn>
        <input
          ref="fileChooser"
          accept=".pdf,.doc,.docx,.xls,.jpg,.jpeg,.png"
          type="file"
          style="display: none"
          @change="onFileChange"
        />
      </v-col>
    </v-row>
    <share-dialog
      title="Share Document"
      :show="showShareDialog"
      @close="showShareDialog = false"
      v-model="sharedItem"
      @contact-client="onContactClient"
      @contact-agent="onContactAgent"
      :key="sharedItem.id"
    ></share-dialog>
    <v-dialog v-model="generateDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          <p>{{ generationMessage }}</p>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <itinerary-map-creator-dialog
      :show="showMapGenerator"
      @close="showMapGenerator = false"
      :itinerary-id="itinerary ? itinerary.id : ''"
    ></itinerary-map-creator-dialog>
    <document-versions-dialog
      :show="showDocumentVersions"
      @close="showDocumentVersions = false"
      v-model="selectedDocument"
    />
    <v-row v-if="debug">
      <code>
        {{ items }}
      </code>
    </v-row>
  </v-container>
</template>
<script>
import BasicDataTable from "../shared/BasicDataTable";

import ItineraryDocumentsListActions from "./ItineraryDocumentsListActions";
import EventBus from "../../../store/event-bus";
import {
  GENERATE_LUGGAGE_CSV,
  GENERATE_MHIKE_EXPORT,
  GENERATE_SAFARI_EXPORT,
  GENERATE_SALES_INVOICES,
  GENERATE_WETU_EXPORT,
  GENERATE_TRAVEFY_EXPORT,
  ITINERARY_DOCS_WITH_AVAILABLE,
  GENERATE_AXUS_EXPORT,
  GENERATE_SP_CALENDAR_EXPORT,
  TASK_STATUS_QUERY,
  UPDATE_ITINERARY_DOC,
  SIGNED_URL_QUERY,
  CREATE_ITINERARY_ATTACHMENT,
} from "../../../constants/graphql";
import AvailableDocumentsListActions from "../shared/AvailableDocumentsListActions";

import {
  removeGQLTypename,
  sortByDate,
  sortByDateField,
} from "../../../helpers/index";
import ShareDialog from "../shared/ShareDialog";
import gql from "graphql-tag";
import ItineraryMapCreatorDialog from "./ItineraryMapCreatorDialog.vue";
const CHECK_INVOICE_GENERATION = gql`
  query checkSalesInvoiceGeneration($id: ID) {
    salesInvoiceGenerationInProgress(itineraryId: $id)
  }
`;
import { GT_HOSTNAME } from "../../../constants/settings";
import DocumentVersionsDialog from "../shared/DocumentVersionsDialog.vue";
const REMOVE_ITI_DOC = gql`
  mutation removeDocument($id: ID!) {
    deleteItineraryDocument(id: $id) {
      id
    }
  }
`;
export default {
  name: "ItineraryDetailsDocumentsList",
  components: {
    BasicDataTable,

    ShareDialog,
    ItineraryMapCreatorDialog,
    DocumentVersionsDialog,
  },
  props: ["itinerary"],

  data() {
    return {
      debug: false,
      uploading: false,
      search: "",
      selectedAttachment: "",
      docsSortBy: "node.updatedAt",
      docsSortDesc: true,
      generateDialog: false,
      showMapGenerator: false,
      headers: [
        { text: "Document", value: "node.name", type: "" },

        {
          text: "Document",
          value: "node.name",
          type: "",
          text: "Created At",
          value: "node.createdAt",
          type: "date",
          sort: sortByDate,
        },
        {
          text: "Updated At",
          value: "node.updatedAt",
          name: "updatedAt",
          type: "dateTime",
          sort: sortByDate,
        },
        { text: "Created by", value: "node.createdBy.name", type: "user" },
        {
          text: "App",
          value: "forApp",
          type: "checkbox",
          handler: this.updateItineraryDoc,
        },
        {
          text: "Actions",
          value: "",
          type: "actions",
          sortable: false,
          actionsComponent: ItineraryDocumentsListActions,
        },
      ],
      availDocsHeaders: [
        { text: "Name", value: "node.name", type: "" },
        {
          text: "Actions",
          value: "",
          type: "actions",
          sortable: false,
          align: "right",
          actionsComponent: AvailableDocumentsListActions,
        },
      ],
      availDocs: [],
      itineraryDocuments: {},
      load: true,
      generatedDocName: "",
      showShareDialog: false,
      sharedItem: { id: 0 },
      taskId: "",
      skipCheckStatus: true,
      travefyAvailable: this.$store.getters.hasAccessTo(
        "itineraries:travefy_export"
      ),
      mhikesAvailable: this.$store.getters.hasAccessTo(
        "itineraries:mhikes_export"
      ),
      safariAvailable: this.$store.getters.hasAccessTo(
        "itineraries:safari_export"
      ),
      wetuAvailable: this.$store.getters.hasAccessTo("itineraries:wetu_export"),
      luggageCSVAvailable: this.$store.getters.hasAccessTo(
        "itineraries:luggage_transfer_report"
      ),
      spCalendarAvailable: this.$store.getters.hasAccessTo(
        "itineraries:sp_calendar_export"
      ),
      axusAvailable: this.$store.getters.hasAccessTo("itineraries:axus_export"),
      draggableWaypoints: [],
      generationMessage: "Generating Sales Invoice(s)",
      selectedDocument: null,
      showDocumentVersions: false,
      documentTypeFilter: null,
      documentTypes: [
        { code: "D", label: "Itinerary Document" },
        { code: "S", label: "Sales Invoice" },
        { code: "P", label: "Purchase Invoice" },
        { code: "V", label: "Voucher" },
        { code: "UNKNOWN", label: "Attachment" },
      ],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    items() {
      const items =
        this.itineraryDocuments && this.itineraryDocuments.edges
          ? this.itineraryDocuments.edges
          : [];
      if (this.documentTypeFilter) {
        return items.filter(this.filterDocuments);
      }
      return items;
    },
  },

  methods: {
    filterDocuments(item) {
      return !this.documentTypeFilter.includes(item.node.documentType);
    },
    handleAttachmentFinish(response) {
      this.onReloadList();
      this.$store.dispatch("showAppSnackbar", {
        msg: "Attachment added",
        color: "success",
      });
      this.uploading = false;
    },
    addDocumentToTheItinerary(response) {
      console.log("addDocumentToTheItinerary response", response);
      this.$apollo
        .mutate({
          mutation: CREATE_ITINERARY_ATTACHMENT,
          variables: {
            input: {
              itineraryId: this.itinerary.id,
              url: response.url,
            },
          },
        })
        .then(this.handleAttachmentFinish, this.handleAttachmentError);
    },
    putAttachmentToTheBucket(result) {
      const response = { ...result.data.signedUrl };
      if (response.url) {
        fetch(response.url, {
          method: "PUT",
          body: this.selectedAttachment,
        }).then(this.addDocumentToTheItinerary, this.handleAttachmentError);
      } else {
        this.handleAttachmentError({ message: "Cannot upload the file!" });
      }
    },
    handleAttachmentError(error) {
      this.uploading = false;
      this.$store.dispatch("showAppSnackbar", {
        msg: error.message,
        color: "danger",
      });
    },
    onUpload() {
      this.$refs.fileChooser.click();
    },
    onFileChange(event) {
      if (this.$refs.fileChooser.files.length > 0) {
        this.uploading = true;
        this.selectedAttachment = this.$refs.fileChooser.files[0];
        this.$apollo
          .query({
            query: SIGNED_URL_QUERY,
            variables: {
              fileName: this.selectedAttachment.name,
            },
          })
          .then(this.putAttachmentToTheBucket, this.handleAttachmentError);
      }
    },
    onGenerateItineraryMap() {
      this.showMapGenerator = true;
    },
    onContactClient(payload) {
      this.showShareDialog = false;
      this.$emit("contact-client", payload);
    },
    onContactAgent(payload) {
      this.showShareDialog = false;
      this.$emit("contact-agent", payload);
    },
    handleRowAction(payload) {
      if (payload.action == "remove") {
        this.removeDocument(payload.id);
      } else if (payload.action == "versions") {
        console.log("versions", payload);
        this.selectedDocument = { ...payload };
        this.showDocumentVersions = true;
      } else {
        this.sharedItem = { ...payload };
        this.showShareDialog = true;
      }
    },
    removeDocument(id) {
      this.$apollo
        .mutate({
          mutation: REMOVE_ITI_DOC,
          variables: { id },
        })
        .then(this.onReloadList)
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("showAppSnackbar", {
            msg: "Cannot remove the document",
            color: "error",
          });
        });
    },
    documentGeneratedHandler(payload) {
      this.showAvailDocsList = false;
      this.load = true;
      this.generatedDocName = payload.name;
    },
    loadData() {
      if (!this.itinerary.id) {
        return false;
      } else {
        return this.load;
      }
    },
    updateItineraryDoc({ node }) {
      if (node.id) {
        this.$apollo
          .mutate({
            mutation: UPDATE_ITINERARY_DOC,
            variables: { input: { id: node.id, forApp: !node.forApp } },
          })
          .then(() => {
            this.load = true;
          })
          .catch((error) => console.log(error));
      }
    },
    generateMHikes() {
      this.generateDialog = true;
      this.generationMessage = "Exporting to MHikes...";
      this.$apollo
        .mutate({
          mutation: GENERATE_MHIKE_EXPORT,
          variables: {
            itineraryId: this.itinerary.id,
          },
        })
        .then(this.generateMHikeHandler, this.generateMHikeErrorHandler);
    },
    generateSafari() {
      this.generateDialog = true;
      this.generationMessage = "Exporting to Safari...";
      this.$apollo
        .mutate({
          mutation: GENERATE_SAFARI_EXPORT,
          variables: {
            itineraryId: this.itinerary.id,
          },
        })
        .then(this.generateSafariHandler, this.handleStandardError);
    },
    generateWetu() {
      this.generateDialog = true;
      this.generationMessage = "Exporting to Wetu...";
      this.$apollo
        .mutate({
          mutation: GENERATE_WETU_EXPORT,
          variables: {
            itineraryId: this.itinerary.id,
          },
        })
        .then(this.generateWetuHandler, this.handleStandardError);
    },
    generateTravefy() {
      this.generateDialog = true;
      this.generationMessage = "Exporting to Travefy...";
      this.$apollo
        .mutate({
          mutation: GENERATE_TRAVEFY_EXPORT,
          variables: {
            itineraryId: this.itinerary.id,
          },
        })
        .then(this.generateTravefyHandler, this.handleStandardError);
    },
    generateSPCalendar() {
      this.generateDialog = true;
      this.generationMessage = "Exporting to SP Calendar...";
      this.$apollo
        .mutate({
          mutation: GENERATE_SP_CALENDAR_EXPORT,
          variables: {
            itineraryId: this.itinerary.id,
          },
        })
        .then(this.generateSPCalendarHandler, this.handleStandardError);
    },
    generateSPCalendarHandler(result) {
      const response = { ...result.data.exportItineraryToSPCalendar };
      if (response.success) {
        this.generateDialog = false;
        this.$store.dispatch("showAppSnackbar", {
          msg: "SP Calendar exported successfully: " + response.message,
          color: "success",
        });
      } else {
        this.handleStandardError(response.message);
      }
    },
    generateAxus() {
      this.generateDialog = true;
      this.generationMessage = "Exporting to Axus...";
      this.$apollo
        .mutate({
          mutation: GENERATE_AXUS_EXPORT,
          variables: {
            itineraryId: this.itinerary.id,
          },
        })
        .then(this.generateAxusHandler, this.handleStandardError);
    },
    generateAxusHandler(result) {
      const response = { ...result.data.exportItineraryToAxus };
      if (response.success) {
        this.generateDialog = false;
        this.$store.dispatch("showAppSnackbar", {
          msg: "Axus exported successfully: " + response.message,
          color: "success",
        });
      } else {
        this.handleStandardError(response.message);
      }
    },
    generateTravefyHandler(result) {
      const response = { ...result.data.exportItineraryToTravefy };
      if (response.success) {
        this.generateDialog = false;
        this.$store.dispatch("showAppSnackbar", {
          msg: "Travefy exported successfully: " + response.message,
          color: "success",
        });
      } else {
        this.handleStandardError(response.message);
      }
    },
    generateWetuHandler(result) {
      const response = { ...result.data.exportItineraryToWetu };
      if (response.success) {
        this.generateDialog = false;
        this.$store.dispatch("showAppSnackbar", {
          msg: "Wetu exported successfully: " + response.message,
          color: "success",
        });
      } else {
        this.handleStandardError(response.message);
      }
    },

    safariMapping() {
      console.log(this.$store.getters.userId);
      window.open(
        `${GT_HOSTNAME}/webforms/safari_mapping/${this.$store.getters.userId}|${this.itinerary.id}`,
        "_blank"
      );
    },
    generateSafariHandler(result) {
      const response = { ...result.data.exportItineraryToSafari };
      if (response.success) {
        this.generateDialog = false;
        this.$store.dispatch("showAppSnackbar", {
          msg: "Safari exported successfully: " + response.message,
          color: "success",
        });
      } else {
        console.log(result);
        this.handleStandardError(response.message);
      }
    },
    handleStandardError(err) {
      this.generateDialog = false;
      this.$store.dispatch("showAppSnackbar", { msg: err, color: "error" });
    },

    generateLuggageCSV() {
      this.generateDialog = true;
      this.generationMessage = "Generating Luggage CSV...";
      this.$apollo
        .mutate({
          mutation: GENERATE_LUGGAGE_CSV,
          variables: {
            itineraryId: this.itinerary.id,
          },
        })
        .then(
          this.generateLuggageCSVHandler,
          this.generateLuggageCSVErrorHandler
        );
    },
    generateLuggageCSVErrorHandler(err) {
      console.log("generateLuggageCSVErrorHandler", err);
      this.generateDialog = false;
      this.$store.dispatch("showAppSnackbar", { msg: err, color: "danger" });
    },
    generateLuggageCSVHandler(result) {
      const response = { ...result.data.generateLuggageCSV };
      if (response.success) {
        this.generateDialog = false;
        this.$store.dispatch("showAppSnackbar", {
          msg: "Generation Complete",
          color: "success",
        });
        this.load = true;
        window.open(response.message);
        //EventBus.$emit("reloadSalesInvoiceList");
      } else {
        this.generateMHikeErrorHandler(response.error);
      }
    },
    generateSalesInvoices() {
      this.$apollo
        .mutate({
          mutation: GENERATE_SALES_INVOICES,
          variables: {
            itineraryId: this.itinerary.id,
          },
        })
        .then(
          this.generateSalesInvoicesHandler,
          this.generateSalesInvoicesErrorHandler
        );
    },
    generateMHikeErrorHandler(err) {
      console.log("generateMHikeErrorHandler", err);
      this.generateDialog = false;
      this.$store.dispatch("showAppSnackbar", { msg: err, color: "danger" });
    },
    generateMHikeHandler(result) {
      const response = { ...result.data.exportItineraryToMhikes };
      if (response.success) {
        this.generateDialog = false;
        this.$store.dispatch("showAppSnackbar", {
          msg: "Generation Complete",
          color: "success",
        });
        this.load = true;
        EventBus.$emit("reloadSalesInvoiceList");
      } else {
        this.generateMHikeErrorHandler(response.error);
      }
    },

    generateSalesInvoicesErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", { msg: err, color: "danger" });
    },
    generateSalesInvoicesHandler(result) {
      this.taskId = result.data.generateSalesInvoice.id;
      this.generateDialog = true;
      this.generationMessage = "Generating Sales Invoices...";
      this.skipCheckStatus = false;
    },
    onReloadList() {
      if (this.$apollo.queries.itineraryDocuments != null) {
        this.load = true;
        this.$apollo.queries.itineraryDocuments.refetch();
      }
    },
  },

  apollo: {
    taskStatus: {
      query: TASK_STATUS_QUERY,
      variables() {
        return { taskId: this.taskId };
      },
      result({ data }) {
        this.skipCheckStatus = true;
        if (data.taskStatus.status == "IN_PROGRESS") {
          setTimeout(() => {
            this.skipCheckStatus = false;
          }, 2000);
        } else {
          this.generateDialog = false;
          if (data.taskStatus.status == "ERROR") {
            this.$store.dispatch("showAppSnackbar", {
              msg: data.taskStatus.message,
              color: "error",
            });
          } else {
            this.$store.dispatch("showAppSnackbar", {
              msg: "Generation Complete",
              color: "success",
            });
            this.load = true;
            EventBus.$emit("reloadSalesInvoiceList");
          }
        }
      },
      skip() {
        return this.skipCheckStatus;
      },
      fetchPolicy: "network-only",
    },
    itineraryDocuments: {
      query: ITINERARY_DOCS_WITH_AVAILABLE,
      variables() {
        return {
          itineraryId: this.itinerary.id,
        };
      },
      result(result) {
        //console.log("docs :", result);
        this.availDocs = result.data.availableDocuments
          ? result.data.availableDocuments.edges.map((item) => ({
              node: { ...item.node, itineraryId: this.itinerary.id },
            }))
          : [];

        this.load = false;
        if (this.generatedDocName != "") {
          const generatedDocs = this.items.filter(
            (item) => item.node.name == this.generatedDocName
          );

          const sortedDocs = generatedDocs
            .map(removeGQLTypename)
            .sort(sortByDateField("updatedAt"));
          const generatedDoc = sortedDocs[sortedDocs.length - 1];
          if (generatedDoc) {
            window.open(
              `${generatedDoc.editURL}&uid=${this.$store.getters.userId}`,
              "_blank"
            );
            this.generatedDocName = "";
          }
        }
      },
      fetchPolicy: "network-only",
      skip() {
        //load onl when we have id
        if (!this.itinerary.id) {
          return true;
        } else {
          return !this.load;
        }
      },
    },
    salesInvoiceGenerationInProgress: {
      query: CHECK_INVOICE_GENERATION,
      variables() {
        return { id: this.itinerary.id };
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.itinerary.id;
      },
      result({ data }) {
        if (data.salesInvoiceGenerationInProgress) {
          this.$store.dispatch("showAppSnackbar", {
            msg: "There is a document being created. Please wait a moment and refresh your screen.",
            color: "warning",
          });
        }
      },
    },
  },
  mounted() {
    EventBus.$on("documentGenerated", this.documentGeneratedHandler);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryDetailsDocumentsList.vue